// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609141609/js/" + chunkId + "." + {"44":"7981fb6c","225":"57b5fdbc","481":"2ddb0405","486":"4f7f0ba7","770":"1315e102"}[chunkId] + ".0.2996783501305904.chunk.js";
};